export const Routes = {
  VAULTS: '/',
  CREATE_VAULT: '/add/vault',
  VAULT_DETAILS: {
    route: '/vault',
    param: '/:chainId/:vaultId',
  },
}
